module.exports = __webpack_public_path__ + "img/room17.b05282c9.gif";